import React, { useState, useCallback, useEffect, useRef } from 'react'

import './index.scss'

export const GnbBtn = ({ setGnbState, gnbState, setMotionState }) => {
  const [btnTit, setBtnTit] = useState('메뉴보기')
  const btnRef = useRef(null)
  useEffect(() => {
    if (gnbState === 'close') {
      setBtnTit('메뉴보기')
      btnRef.current.classList.remove('active')
    }
  })
  const onShowList = useCallback(() => {
    const element = btnRef.current
    if (gnbState === 'close') {
      setBtnTit('메뉴닫기')
      element.classList.add('active')
      setGnbState('open')
      setMotionState(true)
    } else if (gnbState === 'open') {
      setBtnTit('메뉴보기')
      element.classList.remove('active')
      setMotionState(false)
      setTimeout(() => {
        setGnbState('close')
      }, 500)
    }
  }, [gnbState])

  return (
    <button
      className="show-gnb"
      onClick={onShowList}
      ref={btnRef}
      title={btnTit}
    ></button>
  )
}
